import React from 'react';
import { Entry } from 'contentful';

import { GenericAPI } from '@belong/api';
import { FLink, IEntryLink } from '@belong/contentful';
import { getConfig } from '@belong/configs/next/config';
import { setClientLogEndpoint } from '@belong/logging/logger';
import withLink from '@belong/ui-components/components/hocs/withLink';
import { FONT_COLOURS } from '@belong/themes';
import type { ObjectValues } from '@belong/types';
import { Button } from '@belong/ui-components';
import { registerRichTextElements } from '@belong/ui-components/components/styles/Typography/RichText/RichText';
import useAnalyticsEvents from '@belong/providers/analyticsEvents';
import { embeddedLinkClick } from '@belong/analytics';

import { ROUTES } from './routes';

interface IElementLink {
  data: { target: Entry<IEntryLink> };
  hasColor: ObjectValues<typeof FONT_COLOURS>;
}
const ElementLink = ({ data, hasColor }: IElementLink) => {
  const analyticsEvents = useAnalyticsEvents();
  const { label, href, ...otherProps } = FLink(data.target);

  return (
    <Button
      {...otherProps}
      onClick={() => analyticsEvents.send(embeddedLinkClick(href, label))}
      href={href}
      isLightColor={!!hasColor && hasColor === FONT_COLOURS.LIGHT}
    >
      {label}
    </Button>
  );
};
// Setup custom RichText renderers
registerRichTextElements({ elementLink: ElementLink });

const { gateway, basePath } = getConfig().publicRuntimeConfig;
setClientLogEndpoint(`${basePath}/api/log`);

// Configure link renderers
export const routeConfig = withLink.config.clone();
routeConfig.basePath = basePath;
routeConfig.setRoutes(Object.values(ROUTES));
withLink.config = routeConfig;

// Config shared API services
GenericAPI.serviceConfig = { ...gateway, basePath };
